import React from "react";
import "../../../AllComponentCSS.css";
import CodeCopyBlock from "../../../CodeCopyBlock";

const Text_Spacing = () => {
  return (
    <div className="tutorial-container">
      {/* Title */}
      <h1 className="tutorial-title">🔠 CSS Text Spacing</h1>

      {/* Intro */}
      <p className="tutorial-intro">
        CSS provides properties to control the spacing between{" "}
        <strong>letters</strong>, <strong>words</strong>, and{" "}
        <strong>lines</strong>. These properties improve readability and allow
        for better design control.
      </p>

      {/* Letter Spacing */}
      <div className="tutorial-section">
        <h2 className="section-title">Letter Spacing</h2>
        <p>
          The <code>letter-spacing</code> property defines space between
          characters in a text.
        </p>
        <CodeCopyBlock
          code={`p {
  letter-spacing: 4px;
}`}
        />
        <p
          style={{
            letterSpacing: "4px",
            border: "1px solid #ccc",
            padding: "8px",
          }}
        >
          This text has wide letter spacing
        </p>
        <p
          style={{
            letterSpacing: "-1px",
            border: "1px solid #ccc",
            padding: "8px",
          }}
        >
          This text has tight letter spacing
        </p>
      </div>

      {/* Word Spacing */}
      <div className="tutorial-section">
        <h2 className="section-title">Word Spacing</h2>
        <p>
          The <code>word-spacing</code> property sets space between words in a
          text.
        </p>
        <CodeCopyBlock
          code={`p {
  word-spacing: 20px;
}`}
        />
        <p
          style={{
            wordSpacing: "20px",
            border: "1px solid #ccc",
            padding: "8px",
          }}
        >
          This text has large word spacing
        </p>
        <p
          style={{
            wordSpacing: "2px",
            border: "1px solid #ccc",
            padding: "8px",
          }}
        >
          This text has small word spacing
        </p>
      </div>

      {/* Line Height */}
      <div className="tutorial-section">
        <h2 className="section-title">Line Height</h2>
        <p>
          The <code>line-height</code> property controls the vertical spacing
          between lines of text.
        </p>
        <CodeCopyBlock
          code={`p {
  line-height: 2;
}`}
        />
        <p
          style={{ lineHeight: "2", border: "1px solid #ccc", padding: "8px" }}
        >
          This is an example of line height. <br />
          Notice how the space between lines is increased, making the text more
          readable.
        </p>
        <p
          style={{ lineHeight: "1", border: "1px solid #ccc", padding: "8px" }}
        >
          This is another example of line height. <br />
          Here, the lines are closer together.
        </p>
      </div>

      {/* Next Steps */}
      <div className="tutorial-section">
        <h2 className="section-title">Next Steps</h2>
        <p>
          After text spacing, you can explore{" "}
          <a href="/css/fonts" className="learn-more">
            CSS Fonts
          </a>{" "}
          to learn how to style text with different font families, sizes, and
          weights.
        </p>
      </div>
    </div>
  );
};

export default Text_Spacing;
